import { formatInTimeZone } from 'date-fns-tz';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';

export const LatestUpdate = ({ date }: { date: Date | null }) => {
  return (
    <div className={css({ textStyle: 'Text/S/Regular', textAlign: 'right', color: 'content.default.level-1' })}>
      <span>
        <FormattedMessage id='Autogen_common.r251126.s_Latest_update' />
      </span>{' '}
      {date ? (
        <time className={css({ wordBreak: 'break-all' })} dateTime={date.toISOString()} translate='no'>
          <span>{formatInTimeZone(date, 'UTC', 'yy.MM.dd HH:mm')}</span> <span>UTC</span>
        </time>
      ) : (
        '-'
      )}
    </div>
  );
};
